<template>
  <div class="api-section">
    <div class="api-container">
      <h1 class="api-title">REST API</h1>
      <p class="api-text">
        Standalone AGVs and fleet servers provide a REST API that allows integration with external systems, web services, and applications.
      </p>
      <p class="api-text">
        Using standard HTTP methods, developers can communicate with a standalone AGV or a fleet server to retrieve system data, manage orders, and automate workflows.
      </p>

      <h1 class="api-title">Swagger UI</h1>
      <p class="api-text">
        The Swagger UI provides an interactive interface for exploring the API. You can browse endpoints, view request and response formats, and test API calls directly from your browser.
      </p>
      <p class="api-text">
        Both standalone AGVs and the fleet server have their own Swagger pages with up-to-date API documentation.
      </p>
      <p class="api-text">
        Use the button below to access the current endpoints and try out the API in real time.
      </p>

      <GraphicalButton class="api-button" label="Explore REST API (Swagger UI)" @click="openSwaggerUI"></GraphicalButton>
      <h1 class="api-title">API Code Examples</h1>
      <p class="api-text" style="color: gray; font-style: italic; margin-top: 1em;">
        API code examples are under production.
      </p>
    </div>
  </div>
</template>

<script>

import GraphicalButton from "@/components/subcomponents/graphicalButton.vue";
//import Router from "@/router";

export default {
  name: 'Rest-main',
  components: {
    GraphicalButton
  },
  methods: {
    openSwaggerUI() {
      window.open("https://developer.global-agv.com/rest/", "_blank");
    },
    navigateToHowToConnect() {
      //Router.push('rest/Connect');
    }
  },
}
</script>

<style scoped>

.api-section {
  display: flex;
  justify-content: center;
  background-color: #f9f9f9;
}

.api-container {
  width: 100%;
  padding: 30px 40px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  color: #333333;
}

.api-title {
  font-size: 28px;
  border-bottom: 2px solid #e0e0e0;
}

.api-text {
  font-size: 16px;
  line-height: 1.6;
}

</style>
